import { useSwipeable } from 'react-swipeable';

const SwipeableContainer = ({ onSwipedLeft, onSwipedRight, onSwipedUp, onSwipedDown, children, ...containerProps }) => {
  const handlers = useSwipeable({ onSwipedLeft, onSwipedRight, onSwipedUp, onSwipedDown })

  return (<div {...containerProps} {...handlers}>{children}</div>);
};

export default SwipeableContainer;
